import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import logoImg1 from "../../assets/header/logo1.png";
import qr from "../../assets/header/qrCode.png";
import CallIcon from "../../assets/footer/phone.svg";
import EmailIcon from "../../assets/footer/email.svg";
import BusinessIcon from "../../assets/footer/building.svg";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AppRegistrationOutlinedIcon from "@mui/icons-material/AppRegistrationOutlined";
import PortraitOutlinedIcon from "@mui/icons-material/PortraitOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";

const FooterComponent = () => {
  return (
    <footer className="p-3 footer mt-3 pl-4 pr-4 text-white">
      <div className="container">
        <div className="row">
          <div className="col">
            <p>
              <b>Contact</b>
            </p>
            <p className="font18px">
              <i>Kumbhar Mangalam Marriage Matrimony</i>
            </p>
            <p className="font14px">
              <img alt='' src={EmailIcon} className="d-inline-block mr-3"/>
              kumbharmangalaam@gmail.com
            </p>
            <p className="font14px">
            <img alt='' src={CallIcon} className="d-inline-block mr-3"/>
            9272183132
            </p>
            <div className="d-flex">
              <p>
              <img alt='' src={BusinessIcon} className="d-inline-block footerBuildingIcon"/>
              </p>
              <p className="font14px pl-3">
                <i>
                  Office No. 4, 2nd Floor, Darekar Chordia Complex, Opposite
                  Pandit Petrol Pump, Aditya Birla Hospital Marg, Opposite Bank
                  Of Maharashtra Branch Thergaon, Tathwade, Pune 33.
                </i>
              </p>
            </div>
          </div>
          <div className="col text-center font14px">
            <img alt="" className="m-auto desktopView" src={logoImg1} />
            <div>
              All Rights Reserved © Copyright 2021-2025 <br/>Kumbhar Manglam®
            </div>
            <div>* This is marriage website & not for dating purpose.</div>
            <div>Developed and maintained by <a href="http://www.ucsi.in/" target="_blank" className="hyperLink link" rel="noopener noreferrer">UCSI</a></div>
          </div>
           <div className="col text-center phoneView">
            <div className="invisible">
              All Rights Reserved © Copyright 2021-2025 <br/>Kumbhar Manglam®
            </div>
          </div>
          <div className="col text-center desktopView">
            <div className="mb-2">Scan here to pay</div>
            <img alt="" className="m-auto" src={qr} />
          </div>
        </div>
      </div>
      <div className="phoneView footerWrapper">
        <div className="d-flex justify-content-between">
          <div className="phoneFooter d-flex flex-row justify-content-around pt-2">
            <div>
              <Link to="/home" className={`${window.location.href.indexOf("home") > -1 ? 'activeScreen' :''} text-center p-1 p-1`}>
                <HomeOutlinedIcon />
                <p className="mb-0">Home</p>
              </Link>
            </div>
            <div className={`${window.location.href.indexOf("search") > -1 ? 'activeScreen' :''} text-center p-1`}>
              <Link to="/search">
                <SearchIcon />
                <p className="mb-0">Search</p>
              </Link>
            </div>
          </div>
          <div className="text-center registerIcon">
            <Link to="/register">
              <AppRegistrationOutlinedIcon />
            </Link>
          </div>
          <div className="phoneFooter d-flex flex-row justify-content-around pt-1">
            <div className={`${window.location.href.indexOf("profiles") > -1 ? 'activeScreen' :''} text-center p-1`}>
              <Link to="/profiles/unmarried/male">
                <PortraitOutlinedIcon />
                <p className="mb-0">Profiles</p>
              </Link>
            </div>
            <div className={`${window.location.href.indexOf("contact") > -1 ? 'activeScreen' :''} text-center p-1`}>
              <Link to="/contact">
                <ContactPhoneOutlinedIcon />
                <p className="mb-0">Contact Us</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterComponent;
